/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View, Text } from '@components/atoms'
import { ReactComponent as LogoSvg } from '@public/images/logo/logo.svg'
import { grey } from '@mui/material/colors'

interface PropsType {
	className?: string
	imageStyle?: React.CSSProperties
	showCompanyName?: boolean
	logoColor?: string
	textColor?: string
	style?: React.CSSProperties
}

export const Logo: React.FC<PropsType> = (props): JSX.Element => {
	const showCompanyName: boolean = props.showCompanyName ?? true
	const logoColor: string = props.logoColor === undefined ? grey[800] : props.logoColor
	const imageStyle = props.imageStyle ?? {}
	const size = imageStyle.fontSize ?? 20

	return (
		<View css={[style, !showCompanyName ? { width: '4rem' } : null]} {...props}>
			<View className={`innerView ${!showCompanyName ? 'noneTitleInnerView' : ''}`}>
				<LogoSvg
					className="image"
					style={props.imageStyle}
					fill={logoColor}
					width={size}
					height={size}
				/>
				{showCompanyName ? (
					<Text
						className="logoTitle"
						category="s1"
						// hint={props.textColor ?? '800'}
						style={{
							fontSize: '14px',
							color: props.textColor ?? grey['800'],
						}}
					>
						Judahs.io
					</Text>
				) : null}
			</View>
		</View>
	)
}

const style = css({
	height: '1.8rem',
	width: 'fit-content',

	'&& .innerView': {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-start',
		width: 'auto',
		height: '100%',
	},

	'&& .noneTitleInnerView': {
		justifyContent: 'center',
	},

	'.image': {
		display: 'block',
		flexShrink: 0,
		width: 'auto',
		height: '100%',
		marginRight: '0.4rem',
		backfaceVisibility: 'hidden',
	},

	'.logoTitle': {
		marginTop: '1rem',
	},
})
